<div class="background-color">
    <div class="container bg-white pb-4 px-0 mb-3">
        <router-outlet></router-outlet>
    </div>
</div>